module.exports = __webpack_public_path__ + "media/images/navbar-0eb89152aee5253e96a6e9433d08da9e.png";